import { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { Generico } from '../../../components/Generico';
import { FuncionarioService } from '../../../service/ficha/FuncionarioService';
import { LaboralAccionista } from '../../../models/fun/LaboralAccionista';
import { Divider } from 'primereact/divider';
import { DirectorioAccion } from './DirectorioAccion';
import { InputActividadEconomica } from '../../../components/ui/Formularios/InputActividadEconomica';

export const InformacionLaboralAccionista = ({ generic, toast, id, permss, catalogos, handleNext, cliente, nuevoCliente, nextPrev }) => {

    const omodel = new LaboralAccionista();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues, shouldTrim: true });
    const accSrv = new FuncionarioService();
    const formRef = useRef(null);
    const { inDrop, inText, inCalendar } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const { stringToDate } = Generico();
    const [otros, setOtros] = useState(false);
    const [bloquearCampoPep, setBloquearCampoPep] = useState(false);

    useEffect(() => {
        editFicha();
    }, [id]);

    const onSubmit = (data) => {
        data.id = id;
        data.seccion = "seccion3";
        data.fecha_inicio_actividad = data.fecha_inicio_actividad.toISOString().split('T')[0];
        data.otros = catalogos?.otros;
        accSrv.editar(data, 'accionista-pn-bvg').then(res => {
            nuevoCliente({ hay_pep: res.data.hay_pep });
            handleNext();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    const editFicha = () => {
        accSrv.consultar(id, 'accionista-pn-bvg', 'seccion3').then(res => {
            const _cat = catalogos;
            const _dec = res.data.acc;
            if (!_dec) {
                reset(defaultValues);
                return;
            }
            const lista = {
                condicion_laboral: _cat.laboral,
                tipo_entidad: _cat.entidad,
                es_pep: generic.sino,
                otros_directorios: generic.sino,
                participacion_accion: generic.sino
            };
            setOtros(_dec.tipo_entidad === _cat?.otros?.cat_id);

            Object.keys(lista).forEach(function (key) {
                if (_dec[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _dec[key]) {
                            _dec[key] = element;
                        }
                    });
                }
            });
            if (_dec.fecha_inicio_actividad) _dec.fecha_inicio_actividad = stringToDate(_dec.fecha_inicio_actividad);

            if (_dec.pid) {
                setBloquearCampoPep(true);
            }

            reset(generic.renewValues(_dec, omodel.model));
        });
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangeEntidad = (e) => {
        setOtros(e.value?.cat_id === catalogos?.otros?.cat_id);
        if (e.value?.cat_id !== catalogos?.otros?.cat_id) {
            setValue('sector_economico', '');
        }
    }

    return (
        <>
            <form ref={formRef} onSubmit={handleSubmit(onSubmit, onError)}>
                <Panel header="2.- Información Laboral:" className="panel-ficha">
                    <div className="formgrid grid align-items-end">
                        {inDrop('condicion_laboral', catalogos?.laboral, { lab: omodel.optionLabel })}
                        {inDrop('tipo_entidad', catalogos?.entidad, { lab: omodel.optionLabel, chn: onChangeEntidad })}
                        {inText('nombre_empresa')}
                        {inText('cargo')}

                        {otros && inText('sector_economico')}
                        <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} col={6} />
                        {inCalendar('fecha_inicio_actividad')}
                        {inText('direccion_laboral')}

                        {inText('correo_electronico_empresa')}
                        {inDrop('otros_directorios', generic.estadosSiNo, { lab: omodel.optionLabel })}
                        {inDrop('participacion_accion', generic.estadosSiNo, { lab: omodel.optionLabel })}
                    </div>

                    <div className="formgrid grid">
                        <div className="field col-6">
                            <DirectorioAccion id={id} toast={toast} permss={permss} directorio={true} />
                        </div>
                        <div className="field col-6">
                            <DirectorioAccion id={id} toast={toast} permss={permss} directorio={false} />
                        </div>
                    </div>
                </Panel>
                <br />

                <Panel header="3.- Persona Expuesta Políticamente o Públicamente (PEP´s)." className="panel-ficha">
                    {omodel.labelPep}
                    <div className="formgrid grid">
                        <div className="field col-12">
                            Yo, <b>{cliente?.nombre_completo}</b>, con documento de identificación No. <b>{cliente?.identificacion}</b>, he leído las definiciones de “Personas Expuestas Políticamente (PEP’s)”,
                        </div>
                        {inDrop('es_pep', generic.estadosSiNo, { lab: omodel.optionLabel, ne: bloquearCampoPep }, 2)}
                        <div className="field col-10">
                            {omodel.dec2}
                        </div>
                    </div>
                    {omodel.dec3}
                    <Divider />
                    {omodel.dec4}
                </Panel>
                <br />

                {nextPrev()}
            </form>
        </>
    )
}
